import axiosFlowIns from '@/services/axios/axiosFlow'

export default class ClienteService {
  static async getAtendimentosSolicitante(solicitanteId) {
    return axiosFlowIns.get(`tickets/solicitante?IdSolicitante=${solicitanteId}`).then(res => res.data.data)
  }

  static async getSolicitante(solicitanteId) {
    return axiosFlowIns.get(`clientes/${solicitanteId}`).then(res => res.data.data)
  }

  static async createSolicitante(body) {
    return axiosFlowIns.post('clientes/cadastro-solicitante-autoatendimento', body)
  }

  static async updateSolicitante(clienteId, body) {
    return axiosFlowIns.put(`clientes/${clienteId}`, body)
  }

  static async criarSolicitacaoTrocaSenha(body) {
    return axiosFlowIns.post('clientes/solicitacoes-troca-senha ', body)
  }

  static async reenviarSolicitacaoTrocaSenha(solicitacaoAnteriorId, body) {
    return axiosFlowIns.put(`clientes/solicitacoes-troca-senha/${solicitacaoAnteriorId}`, body)
  }

  static async validarAcessoAoLinkDeRedefinicaoDeSenha(solicitacaoAnteriorId) {
    return axiosFlowIns.get(`clientes/solicitacoes-troca-senha/${solicitacaoAnteriorId}`)
  }

  static async criarNovaSenha(body) {
    return axiosFlowIns.put('clientes/reset-senha', body)
  }
}
